import React from 'react';
import { Button } from 'antd';
import CommonListsIndex from '../../components/CommonLists/index';
import SinglePagesList from './list';

class SinglePages extends CommonListsIndex {
  constructor() {
    super();
    this.api = 'singlePages';
    this.addComponent = ``;
    this.editComponent = ``;
    this.listsComponent = SinglePagesList;
  }
  componentDidMount() {
    this.freshQueryList();
    this.editComponent = `/content/singlePages/id/edit`;
    this.addComponent = `/content/singlePages/add`;
  }

  freshQueryList = () => {
    this.queryList({});
  };

  render() {
    const ListsComponent = this.listsComponent;
    return (
      <div>
        <div className="tantuer-op">
          <Button type="primary" icon="plus" onClick={this.add}>
            新增
          </Button>
        </div>

        <ListsComponent
          data={this.state.listsData}
          edit={this.edit}
          queryList={this.freshQueryList}
        />
      </div>
    );
  }
}
export default SinglePages;
